import EmbedNotFound from 'v2/pages/embed/embed-not-found'
import { NotFoundPage } from 'v2/pages/misc/404'
import { isEmbedMode } from 'v2/shared/utils/embed-session'

// The console 404 links home, which is the console login inside a partner's iframe.
export const AgentNotFound = () =>
  isEmbedMode() ? <EmbedNotFound message="This agent is not available." /> : <NotFoundPage />
